export default function IconBack() {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
      <title>Icon of a arrow pointing left that closes the image preview</title>
      <path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z"/>
    </svg>
  )
}